export default function Home() {
  return <>Nothing to see here...</>;
}
